
import Event = createjs.Event;

export class Poker2AvatarEvent extends Event {
    //item id, current color,shop state (shop, inventory)
    public static AVATAR_CHANGED: string = "avatarChanged";
    //item id, color id, state
    //		public static const AVATAR_COLORCHANGED:String = "avatarColorChanged";
    //item id, color id
    public static AVATAR_CLOTHESCHANGED: string = "avatarClothesChanged";
    public static AVATAR_RESET: string = "avatarReset";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
